import { render, staticRenderFns } from "./weirdMailingAlert.vue?vue&type=template&id=d1fb82b8&"
import script from "./weirdMailingAlert.vue?vue&type=script&lang=ts&"
export * from "./weirdMailingAlert.vue?vue&type=script&lang=ts&"
import style0 from "./weirdMailingAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports